import { useContext } from "react";
import { TStyleConnotation } from "../../../types";
import { Alert, FormRow, Link, Typography } from "../../util";
import { LocationContext } from "../../../contexts";
import { urls } from "../../../config/appConfig";
import { brand } from "../../../config/brand";

export const AlertBox = ({ message, color }: iAlertBoxProps) => {
  let includeLink = false;
  let includeLogin = false;

  const { urlParams } = useContext(LocationContext);

  let loginLink = "/login";
  if (urlParams?.visitor_role) {
    loginLink = `/login?visitor_role=${urlParams.visitor_role}`;
  }

  const contactUs = (
    <Link href={urls.careContact}>contact {brand.shortName}</Link>
  );

  const login = (
    <>
      {" "}
      <Link href={loginLink}>Login</Link>
    </>
  );

  // "contact Care" is a literal sentinel emitted by the backend error copy
  // (not user-facing brand text), so it's matched as-is regardless of brand.
  if (message.includes("contact Care")) {
    includeLink = true;
    message = message.replaceAll("contact Care", " ");
  } else if (message.toLowerCase().includes("account already exists")) {
    includeLogin = true;
  }

  return (
    <>
      <FormRow>
        <Alert color={color}>
          <Typography>
            {message}
            {includeLink && contactUs}
            {includeLogin && login}
          </Typography>
        </Alert>
      </FormRow>
    </>
  );
};

export interface iAlertBoxProps {
  message: any | string;
  color: TStyleConnotation;
}
